import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/5213310902798"
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-20 right-5 sm:right-6 z-50 w-14 h-14 rounded-full flex items-center justify-center text-white rp-anim-pulse-ring transition-transform hover:scale-110"
      style={{ background: "#25d366", boxShadow: "0 10px 30px -10px rgba(37, 211, 102, 0.7)" }}
    >
      <MessageCircle className="w-7 h-7" />
      <span className="sr-only">WhatsApp</span>
    </a>
  );
}
